export const ValidationDashboardUrl = {
  SEARCH:
    '/validation-dashboards{?page,size,sort*,dataObjectDescriptionId,dashboardType,createdBy}',
  ENTITY: '/validation-dashboards{/id}',
  CROSSTABLE: '/validation-dashboards/crosstable',
  CROSSTABLE_DUPLICATE:
    '/validation-dashboards/crosstable/duplicate/{externalCode}',
  CROSSTABLE_CHANGE_DATA:
    '/validation-dashboards/crosstable/change-data/{externalCode}',
  HODRICK_PRESCOTT: '/validation-dashboards/hodrick-prescott',
  HODRICK_PRESCOTT_COMPARISON:
    '/validation-dashboards/hodrick-prescott-comparison',
  HODRICK_PRESCOTT_COMPARISON_DUPLICATE:
    '/validation-dashboards/hodrick-prescott-comparison/duplicate/{externalCode}',
  HODRICK_PRESCOTT_COMPARISON_CHANGE_DATA:
    '/validation-dashboards/hodrick-prescott-comparison/change-data/{externalCode}',
  HODRICK_PRESCOTT_DUPLICATE:
    '/validation-dashboards/hodrick-prescott/duplicate/{externalCode}',
  HODRICK_PRESCOTT_CHANGE_DATA:
    '/validation-dashboards/hodrick-prescott/change-data/{externalCode}',
  OUTLIERS: '/validation-dashboards/outliers',
  OUTLIERS_COMPARISON: '/validation-dashboards/outliers-comparison',
  OUTLIERS_COMPARISON_DUPLICATE:
    '/validation-dashboards/outliers-comparison/duplicate/{externalCode}',
  OUTLIERS_COMPARISON_CHANGE_DATA:
    '/validation-dashboards/outliers-comparison/change-data/{externalCode}',
  OUTLIERS_DUPLICATE:
    '/validation-dashboards/outliers/duplicate/{externalCode}',
  OUTLIERS_CHANGE_DATA:
    '/validation-dashboards/outliers/change-data/{externalCode}',
  TIME_SERIES: '/validation-dashboards/time-series',
  TIME_SERIES_DUPLICATE:
    '/validation-dashboards/time-series/duplicate/{externalCode}',
  TIME_SERIES_CHANGE_DATA:
    '/validation-dashboards/time-series/change-data/{externalCode}',
  COMPARISON: '/validation-dashboards/comparison',
  COMPARISON_DUPLICATE:
    '/validation-dashboards/comparison/duplicate/{externalCode}',
  COMPARISON_CHANGE_DATA:
    '/validation-dashboards/comparison/change-data/{externalCode}',
  TIME_SERIES_COMPARISON: '/validation-dashboards/time-series-comparison',
  TIME_SERIES_COMPARISON_DUPLICATE:
    '/validation-dashboards/time-series-comparison/duplicate/{externalCode}',
  TIME_SERIES_COMPARISON_CHANGE_DATA:
    '/validation-dashboards/time-series-comparison/change-data/{externalCode}',
} as const;
